import { RoiDataReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: RoiDataReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const roiDataReducer = createReducer(initialState, {
  GET_ROI_DATA_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_ROI_DATA_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_ROI_DATA_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default roiDataReducer;
